<template>
  <v-container id=create-marker-container fluid>
      <v-row>
        <v-col>
          <span class="title">CREATE NEW ACCOUNT</span>
          <v-text-field v-model="email" label="E-mail" prepend-icon="mdi-email" required></v-text-field>
          <v-text-field v-model="name" label="Artist Name" prepend-icon="mdi-account-box" required></v-text-field>
          <v-text-field v-model="password" :type="'password'" name="input-10-1" prepend-icon="mdi-lock" label="Password" ></v-text-field>
          <v-text-field v-model="passwordVerification" :type="'password'" name="input-10-1" prepend-icon="mdi-lock" label="Repeat Password" ></v-text-field>
          <v-btn color="red darken-1" text @click="createAccount">OK</v-btn>
        </v-col>
      </v-row>
    <v-alert v-show="errorMessage" dense type="error">{{errorMessage}}</v-alert>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SignUpForm',
  components: {},
  props: {},
  data: () => ({
    //email: "",
    email: window.localStorage.getItem('emailForSignIn'),
    name: "",
    password: "",
    passwordVerification: "",
  }),
  computed: mapState({
    errorMessage: 'errorMessage',
    //email: 'linkEmail',
  }),
  created () {
    this.$store.dispatch('loadEmail');
  },
  methods: {
    async createAccount() {
      this.$store.dispatch(
        "createAccount",
        {name: this.name, email: this.email, password: this.password, passwordCheck: this.passwordVerification});
    }
  },
}
</script>

<style>
#create-marker-container {
  background: black;
}
#create-marker-container *{
  color: red;
  border-color: red;
}

#create-marker-container .red--text {
  background: red;
}
#create-marker-container .red--text *{
  color: black;
}
</style>
